import { SearchParameter } from "@/enums";

export const routes = {
  admin: {
    permissions: {
      add: "/admin/permissions/new",
      get: (permissionId: string): string =>
        `/admin/permissions/${permissionId}`,
      list: "/admin/permissions",
    },
    users: {
      list: "/admin/users",
      get: (id: string): string => `/admin/users/${id}`,
      add: "/admin/users/add",
    },
    forms: {
      list: "/admin/forms",
      get: (formType: string): string => `/admin/forms/${formType}`,
      field: {
        get: (formType: string, id: string): string =>
          `/admin/forms/${formType}/fields/${id}`,
        new: (formType: string): string =>
          `/admin/forms/${formType}/fields/new`,
        newDependent: (formType: string, parentId: string): string =>
          `/admin/forms/${formType}/fields/new?parent=${parentId}`,
      },
    },
    projectRoles: {
      get: (templateRoleId: string): string =>
        `/admin/projectRoles/${templateRoleId}`,
      list: "/admin/projectRoles",
      add: "/admin/projectRoles/new",
    },
    approvalWorkFlows: {
      get: (approvalWorkFlowsId: string): string =>
        `/admin/approvalWorkFlows/${approvalWorkFlowsId}`,
      list: "/admin/approvalWorkFlows",
      add: "/admin/approvalWorkFlows/new",
      addDependentApprover: (
        approvalWorkFlowsId: string,
        approverId: string
      ): string =>
        `/admin/approvalWorkFlows/${approvalWorkFlowsId}/new/${approverId}`,
    },
    conditionalAccess: {
      list: "/admin/conditionalAccess",
      get: (id: string): string => `/admin/conditionalAccess/${id}`,
    },
    projectTemplates: {
      list: "/admin/projectTemplates",
      edit: (templateId: string): string =>
        `/admin/projectTemplates/edit/${templateId}`,
    },
    apiDocumentation: `/admin/api/v1`,
    notificationGroups: {
      list: "/admin/notificationGroups",
    },
    baselineDates: {
      edit: (projectTypeId: string, baselineDateId: string): string =>
        `/admin/baselineDates/${projectTypeId}/${baselineDateId}`,
      list: "/admin/baselineDates",
      create: "/admin/baselineDates/create",
    },
    adminConfig: {
      list: "/admin/config",
    },
    userReplacement: {
      view: "/admin/userReplacement",
      history: "/admin/userReplacement/history",
    },
  },
  dashboardFullViews: {
    pendingIntakeApprovals: "/dashboard/pending-intake-approvals",
    pendingMilestoneApprovals: "/dashboard/pending-milestone-approvals",
    recentlyApprovedIntake: "/dashboard/recently-approved-intakes",
    recentlyApprovedMilestones: "/dashboard/recently-approved-milestones",
    routingMilestoneApprovals: "/dashboard/routing-milestone-approvals",
  },
  dashboard: "/",
  forbidden: (): string =>
    `/forbidden?referrerUrl=${
      window.location.pathname + window.location.search
    }`,
  initiatives: {
    list: "/initiatives",
    new: "/initiatives/new",
    edit: (initiativeId: string): string => `/initiatives/${initiativeId}`,
  },
  projects: {
    list: "/projects",
    get: (projectId: string): string => `/projects/${projectId}`,
    new: "/projects/intake/new",
    intakeView: (projectId: string): string => `/projects/intake/${projectId}`,
    team: (projectId: string): string => `/projects/${projectId}/team`,
    history: (projectId: string): string => `/projects/${projectId}/history`,
    risksAndIssues: (projectId: string): string => `/projects/${projectId}/risks-and-issues`,
    vpinHistory: (projectId: string): string =>
      `/projects/${projectId}/vpinhistory`,
    getMilestone: (
      projectId: string,
      milestoneId: string,
      scheduleId: string
    ): string => {
      const parameters = new URLSearchParams({
        [SearchParameter.Milestone]: milestoneId,
      });

      if (scheduleId) {
        parameters.append(SearchParameter.Schedule, scheduleId);
      }

      return `/projects/${projectId}?${parameters}`;
    },
  },
};
